import { Card, Col, Container, Row } from "react-bootstrap";

export default function WaitOnDemandV2({secondStep, title, handleWait}){

    return (
        <Container>
            <Row>
                <Col xs="12" md={{span: 10, offset: 1}}>
                    <Card className='mt-2 mb-5 shadow-sm'>
                        <Card.Body className="p-5">
                            <h5 className="colorLink mb-4 text-center">{title}</h5> 
                            {secondStep &&
                            <div className="d-flex justify-content-center">
                                <div>
                                    <button
                                        onClick={e=>handleWait(true)}
                                    >
                                        Continuar en espera
                                    </button>
                                </div>
                                <div>
                                    <button
                                        onClick={e=>handleWait(false)}
                                    >
                                        Programar cita
                                    </button>
                                </div>
                            </div>}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )

}